var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoactionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 5.71427C13.1426 8.55998 7.99979 15.4286 7.99979 15.4286C7.99979 15.4286 2.85693 8.55998 2.85693 5.71427C2.85693 4.3503 3.39877 3.04219 4.36324 2.07772C5.32771 1.11325 6.63582 0.571411 7.99979 0.571411C9.36376 0.571411 10.6719 1.11325 11.6363 2.07772C12.6008 3.04219 13.1426 4.3503 13.1426 5.71427V5.71427Z",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 7.42857C8.94646 7.42857 9.71397 6.66106 9.71397 5.71429C9.71397 4.76751 8.94646 4 7.99969 4C7.05291 4 6.2854 4.76751 6.2854 5.71429C6.2854 6.66106 7.05291 7.42857 7.99969 7.42857Z",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoactionicon);
export default __webpack_public_path__ + "static/media/loactionicon.a94aaa66befcf6898ca367b81b981b97.svg";
export { ForwardRef as ReactComponent };